// src/hooks/useResultPages.ts

import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
} from "firebase/firestore";

import { db } from "../firebase";
import { useLoading } from "./useLoading";

export interface ResultPageItem {
  id: string;
  type: string;
  published: boolean;
}

export interface ResultPagesData {
  id: string;
  year: string;
  createdAt?: any;
  updatedAt?: any;
  finalistCount?: number | null;
  pages: {
    quartetSemiFinal: ResultPageItem;
    quartetFinal: ResultPageItem;
    chorusFinal: ResultPageItem;
    evaluationOnly: ResultPageItem;
  };
}

export const useResultPages = () => {
  const [resultPages, setResultPages] = useState<
    ResultPagesData[]
  >([]);

  const { isLoading, setIsLoading } =
    useLoading();

  const fetchResultPages = async () => {
    try {
      setIsLoading(true);

      const querySnapshot = await getDocs(
        collection(db, "resultPages"),
      );

      const list = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<
          ResultPagesData,
          "id"
        >),
      }));

      // 年順
      list.sort(
        (a, b) => Number(b.id) - Number(a.id),
      );

      setResultPages(list);
    } catch (error) {
      console.error(
        "resultPages取得エラー:",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchResultPages();
  }, []);

  return {
    loading: isLoading,
    resultPages,
    fetchResultPages,
  };
};